import { LoginNotice as LoginNoticeComponent } from '@teliaee/telia-common-components';
import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import config from '../Config';
import { useStores } from '../stores/RootStore';

const LoginNotice = observer((): React.JSX.Element => {
  const { contentStore, segmentStore, ssoStore, languageStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const [isClientSideRender, setIsClientSideRender] = React.useState(false);
  const clientType = segmentStore.currentSegment.toLowerCase();

  React.useEffect(() => {
    setIsClientSideRender(true);
  }, []);

  const shouldShowNotice = () => {
    return isClientSideRender && contentStore.currentPageContent.showLoginNotice && ssoStore.isSsoLoaded && !ssoStore.customer;
  };

  return (
    <LoginNoticeComponent
      language={languageStore.currentLanguage}
      tier={config.componentTier}
      showNotice={shouldShowNotice()}
      ensureLogin={ssoStore.ensureLogin}
      translations={{ cta: translate('loginNotice.cta.text'), text: translate(`loginNotice.text.${clientType}`) }}
    />
  );
});

export default LoginNotice;
